// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commoly-item[data-v-1c8beb52]{width:calc(50% - %?6?%)}", ""]);
// Exports
module.exports = exports;
